// src/icons/AmericanExpressLogo.tsx
import { jsx, jsxs } from "react/jsx-runtime";
function AmericanExpressLogo({
  title,
  titleId,
  ...props
}) {
  return /* @__PURE__ */ jsxs("svg", {
    "aria-hidden": "true",
    "aria-labelledby": titleId,
    fill: "none",
    height: 6,
    viewBox: "0 0 24 6",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: [
      title ? /* @__PURE__ */ jsx("title", {
        id: titleId,
        children: title
      }) : null,
      /* @__PURE__ */ jsx("path", {
        clipRule: "evenodd",
        d: "M3.06297 0.130859L0.473877 5.86045H3.57339L3.95764 4.94691H4.83595L5.2202 5.86045H8.63189V5.16321L8.93589 5.86045H10.7007L11.0047 5.14847V5.86045H18.1001L18.9629 4.97064L19.7707 5.86045L23.4151 5.86782L20.8178 3.01165L23.4151 0.130859H19.8272L18.9874 1.00423L18.205 0.130859H10.4861L9.82328 1.60971L9.14491 0.130859H6.05187V0.804374L5.70779 0.130859H3.06297ZM13.6588 0.94514H17.7333L18.9795 2.29127L20.2659 0.94514H21.5121L19.6186 3.01151L21.5121 5.05407H20.2093L18.9631 3.69231L17.6702 5.05407H13.6588V0.94514ZM14.6647 2.54686V1.79633V1.79561H17.207L18.3164 2.9959L17.1579 4.20274H14.6647V3.38338H16.8875V2.54686H14.6647ZM3.66283 0.94514H5.17367L6.89102 4.83041V0.94514H8.5461L9.87255 3.73086L11.095 0.94514H12.7418V5.0565H11.7398L11.7316 1.83486L10.2707 5.0565H9.37435L7.90529 1.83486V5.0565H5.84386L5.45305 4.13478H3.34166L2.95166 5.05569H1.84717L3.66283 0.94514ZM3.70224 3.28246L4.39786 1.64051L5.09267 3.28246H3.70224Z",
        fill: "currentColor",
        fillRule: "evenodd"
      })
    ]
  });
}
export {
  AmericanExpressLogo
};
//# sourceMappingURL=AmericanExpressLogo.mjs.map